/**
 * @readonly
 * @enum {string}
 */
export const CameraSpeedUnits = {
    KMH: 'KPH',
    MPH: 'MPH'
}
